import axios from "axios";

window.axios = axios

// Для работы с order.js напрямую нужно раскоментировать fuse.js, axios.min.js, api.js, order.js и закоментировать строку с order.min,js
// Также необходимо закомментировать строки кода с импортом и экспортом в файлах order.js и new_order/api.js.

// Для создания билда вам необходимо выполнить все описанные ранее действия в обратном порядке.


var userTimeZone = 'None'

try {
    userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
} catch (err) {
    console.log('Timezone detection error', err)
}

axios.interceptors.request.use(
    function (config) {
        config.headers['user-timezone'] = userTimeZone
        return config
    }, 
    function (error) {
        return Promise.reject(error)
    }
)

const endPoint = '/reg-sms.api.php'
let API = {}

API.getNumber = async function(opt) {

  // console.log("GET_NUMBER")
  // console.log(opt)
  // return

  try {
    const query = {
      type: 'get_number',
      country_id: opt.country,
      operator: opt.operator,
      service: opt.serviceId,
      voice: opt.voice,
      id: 1,
      redirectphone: 0
    }

    if (opt.isForward) {
      query['redirectphone'] = 1
      query['number_redirect'] = opt.forwardTo
    }

    if (opt.waitVoiceCode) {
      query['waitvoicecode'] = 1
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.denialPhone = async function(opt) {
  try {
    const query = {
      type: 'denial',
      id: opt.id
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.banPhone = async function(opt) {
  try {
    const query = {
      type: 'ban',
      id: opt.id
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.getCode = async function(opt) {
  try {
    const query = {
      type: 'get_sms',
      country_id: opt.country,
      operator: opt.operator,
      service: opt.serviceId,
      id: opt.id,
      redirectphone: 0
    }

    if (opt.isForward) {
      query['redirectphone'] = 1
      query['number_redirect'] = opt.forwardTo
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.getServices = async function(countryId, operatorId) {
  try {
    const query = {
      type: 'test',
      country_id: countryId || 179,
      operator_id: operatorId || 7
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.getCount = async function() {
  try {
    const query = {
      type: 'test2'
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.checkRepeatCode = async function(opt) {
  try {
    const query = {
      type: 'get_clearsms',
      id: opt.id
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.stopSMS = async function(opt) {
  try {
    
    const query = {
      type: 'stop_sms',
      id: opt.id
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.setForwarding = async function(opts) {
  try {
    const query = {
      type: 'redirect',
      service: opts.serviceId,
      id: opts.id,
      operator: opts.operator,
      country_id: opts.country,
      redirectphone: opts.isForward ? '1' : '0',
      number_redirect: opts.forwardTo || '0000000000',
      amount: opts.addToBalance
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.getPrices = async function(country_id) {
  try {
    const query = {
      type: 'get_prices_by_country',
      country_id: country_id
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.getPriceChanges = async function() {
  try {
    const query = {
      type: 'get_price_changes'
    }

    const response = await axios.get(endPoint, { params: query });
    return response.data;
  } catch (error) {
    throw error;
  }
}

API.getActiveOrders = async function() {
  try {
    const query = {
      type: 'get_orders'
    }

    const response = await axios.get(endPoint, { params: query });

    // return {"status":1,"orders":[{"id":167385529,"number":"61684887","countrycode":"+370","status":1,"opt":"opt29","secondsleft":488,"sms":"","code":"","type":4,"country":"LT"}]}

    return response.data;
  } catch (error) {
    throw error;
  }
}

window.ORDER_PAGE_API = API

// export default API
